<template>
  <div class="enrollWrapper">
    <my-info-noti/>
    <div class="leftSideWrapper">
      <div class="leftSideContentWrapper">
        <div class="largeHeadLine">광고하기</div>
        <div class="mainContentsWrapper">
          <span class="itemName">질문</span>
          <div class="elementWrapper" v-bind:style="style.titleWrapper">
            <div class="titleImgWrapper">
              <input-img-title></input-img-title>
            </div>
            <div class="titleInputTextWrapper">
              <input-text-title></input-text-title>
            </div>
          </div>
          <span class="itemName">답변</span>
          <div class="elementWrapper" v-bind:style="style.answerWrapper">
            <div class="answerInputDiv" v-for="count in displayAnswerCountsArray" v-bind:key="count">
              <answer v-if="isAnswerShown(count)" v-bind:answer-count="count" v-on:reduceAnswerCount="setAnswerCountReduce"></answer>
              <div v-if="!isAnswerShown(count)" class="answerAddBtn" v-on:click="setAnswerCountArrays(count)">
                <span>{{'답변 ' + count + ' 추가'}}</span>
              </div>
            </div>
          </div>
          <span class="itemName">#카테고리</span>
          <div class="elementWrapper" v-bind:style="style.categoryWrapper">
            <check-item v-for="item in categoryItems" v-bind:key="item.itemKey" v-bind:type="item.type" v-bind:item-key="item.itemKey" v-bind:text="item.text" v-bind:flex-ratio="item.flexRatio"></check-item>
          </div>
          <div class="sectionLine" v-bind:style="'margin-bottom: 20px;'"></div>
          <span class="itemName">광고대상</span>
          <div class="elementWrapper" v-bind:style="style.towardWrapper">
            <check-item v-for="item in towardItems" v-bind:key="item.itemKey" v-bind:type="item.type" v-bind:item-key="item.itemKey" v-bind:text="item.text" v-bind:flex-ratio="item.flexRatio"></check-item>
          </div>
          <span class="itemName">성별</span>
          <div class="elementWrapper" v-bind:style="style.genderWrapper">
            <check-item v-for="item in genderItems" v-bind:key="item.itemKey" v-bind:type="item.type" v-bind:item-key="item.itemKey" v-bind:text="item.text" v-bind:flex-ratio="item.flexRatio"></check-item>
          </div>
          <span class="itemName">직업 (복수가능)</span>
          <div class="elementWrapper" v-bind:style="style.jobWrapper">
            <check-item-duplicate v-for="item in jobsItems" v-bind:key="item.itemKey" v-bind:type="item.type" v-bind:item-key="item.itemKey" v-bind:text="item.text" v-bind:flex-ratio="item.flexRatio"></check-item-duplicate>
          </div>
          <span class="itemName">연령대 (복수가능)</span>
          <div class="elementWrapper" v-bind:style="style.ageWrapper">
            <check-item-duplicate v-for="item in ageItems" v-bind:key="item.itemKey" v-bind:type="item.type" v-bind:item-key="item.itemKey" v-bind:text="item.text" v-bind:flex-ratio="item.flexRatio"></check-item-duplicate>
          </div>
          <span class="itemName">지역 (최대 5구역)</span>
          <div class="elementWrapper" v-bind:style="style.regionWrapper">
            <div class="areaInputDiv" v-for="index in displayAreasCountsArray" v-bind:key="index">
              <region-select-box v-if="isAreaShown(index)" v-bind:region-count="index"></region-select-box>
              <span class="deleteAreaText" v-if="isAreaShown(index)" v-on:click="deleteArea(index)">삭제</span>
              <div v-if="!isAreaShown(index)" class="areaAddBtn" v-on:click="setAreaCountArrays(index)">
                <img v-bind:src="addDistrictImg">
                <span>{{'지역 추가'}}</span>
              </div>
            </div>
          </div>
          <div class="sectionLine" v-bind:style="'margin-bottom: 20px;'"></div>
          <span class="itemName">보상방법</span>
          <div class="elementWrapper" v-bind:style="style.rewardWrapper">
            <div class="rewardElementDiv">
              <check-item v-bind:type="rewardItems[0].type" v-bind:item-key="rewardItems[0].itemKey" v-bind:text="rewardItems[0].text" v-bind:flex-ratio="rewardItems[0].flexRatio"></check-item>
              <div class="rewardInputDiv" v-show="isRewardTypeCoupon != null && isRewardTypeCoupon">
                <span>내용&nbsp;</span>
                <input-text-coupon></input-text-coupon>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;기한&nbsp;&nbsp;&nbsp;</span>
                <enroll-date-input v-bind:type="'expiredDate'" v-bind:style="'margin-top : 0;'"></enroll-date-input>
              </div>
            </div>
            <div class="rewardElementDiv">
              <check-item v-bind:type="rewardItems[1].type" v-bind:item-key="rewardItems[1].itemKey" v-bind:text="rewardItems[1].text" v-bind:flex-ratio="rewardItems[1].flexRatio"></check-item>
              <div class="rewardInputDiv" v-show="isRewardTypeCoupon != null && !isRewardTypeCoupon">
                <span>포인트&nbsp;&nbsp;&nbsp;</span>
                <input class="rewardPointValue" type="text" v-bind:value="rewardPoint" v-on:focus="removeZeroValue" v-on:blur="setPollidePoint" v-on:keydown="onlyNumber">
                <span>&nbsp;&nbsp;P</span>
              </div>
            </div>
          </div>
          <div class="sectionLine" v-bind:style="'margin-bottom: 20px;'"></div>
          <span class="itemName">기간</span>
          <div class="elementWrapper" v-bind:style="style.periodWrapper">
            <div class="periodInputDiv">
              <span>시작날짜</span>
              <enroll-date-input v-bind:type="'start'"></enroll-date-input>
            </div>
            <div class="periodInputDiv">
              <span>종료날짜</span>
              <enroll-date-input v-bind:type="'end'"></enroll-date-input>
            </div>
          </div>
          <span class="itemName">일일예산</span>
          <div class="elementWrapper" v-bind:style="style.budgetWrapper">
            <budget-input></budget-input>
          </div>
          <span class="itemName">결제포인트</span>
          <div class="elementWrapper" v-bind:style="style.payPointWrapper">
            <div class="payPointInputDiv">
              <span>보유 포인트</span>
              <div>
                <span>{{adPoint.toLocaleString() + '원'}}</span>
              </div>
            </div>
            <div class="payPointInputDiv">
              <span>사용할 포인트</span>
              <div>
                <span>{{$store.getters.getEnrollStateValue('totalBudget').toLocaleString() + '원'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <board-footer></board-footer>
    </div>
    <div class="rightSideWrapper">
      <div class="mobileUIWrapper">
        <advertise-ui v-bind:data="uiPropData"></advertise-ui>
      </div>
      <div class="actionBtnWrapper">
        <button class="temporaryRemoveBtn" v-show="isEnrollByTemporary" v-on:click="temporaryDelete"><img v-bind:src="temporaryRemoveImg"></button>
        <button class="temporaryBtn" v-on:click="temporaryEnroll">임시저장</button>
        <button class="enrollBtn" v-on:click="enrollValidCheck">광고올리기</button>
        <valid-noti/>
      </div>
    </div>
  </div>
</template>

<script>
import params from '../../../params.js'
import inputTextTitle from '../../board/elements/enrollInputTextTitle.vue'
import inputImgTitle from '../../board/elements/enrollInputImgTitle.vue'
import inputTextCoupon from '../elements/enrollInputTextCoupon'
import answer from '../../board/elements/answerInput.vue'
import checkItem from '../../board/elements/checkItem.vue'
import checkItemDuplicate from '../../board/elements/checkItemDuplicate.vue'
import regionSelectBox from '../../board/elements/regionSelectBox.vue'
import enrollDateInput from '../../board/elements/enrollDateInput.vue'
// import budgetInput from '../../board/elements/budgetInput.vue'
import advertiseUI from '../elements/advertiseUI'
import myInfoNotiModal from '../../board/elements/myInfoModifyNotificationModal'
import enrollValidNotiModal from '../../board/elements/enrollValidNotificationModal'
import boardFooterLeftSide from '../elements/boardFooterLeftSide'
import utils from '../../../assets/js/utils'
import store from '../../../store'
const budgetInput = ''

export default {
  components: {
    'input-text-title': inputTextTitle,
    'input-img-title': inputImgTitle,
    'input-text-coupon': inputTextCoupon,
    'answer': answer,
    'check-item': checkItem,
    'check-item-duplicate': checkItemDuplicate,
    'region-select-box': regionSelectBox,
    'enroll-date-input': enrollDateInput,
    'budget-input': budgetInput,
    'advertise-ui': advertiseUI,
    'my-info-noti': myInfoNotiModal,
    'valid-noti': enrollValidNotiModal,
    'board-footer': boardFooterLeftSide
  },
  data () {
    return {
      // 임시저장 광고로부터 광고올리기 페이지에 도달한 경우 : true, 그렇지 않을경우 : false
      isEnrollByTemporary: false,
      // 임시저장 광고로부터 광고올리기 페이지에 도달한 경우 : 광고 id 받아옴
      temporaryAdId: null,
      // 보상방법 쿠폰: true, 포인트: false
      isRewardTypeCoupon: null,
      answerCountsArray: [],
      displayAnswerCountsArray: [],
      areasCountsArray: [],
      displayAreasCountsArray: [],
      categoryItems: params.category,
      towardItems: params.toward,
      genderItems: params.gender,
      jobsItems: params.job,
      ageItems: params.age,
      rewardItems: params.reward,
      rewardPoint: 0,
      adPoint: 0,
      availableAdPoint: 0,
      // 핸드폰 UI프롭 데이터
      uiPropData: {
        isRewardTypeCoupon: false,
        titleText: null,
        titleImg: null,
        answerText: [null, null, null, null],
        answerImg: [null, null, null, null]
      },
      temporaryRemoveImg: require('@/assets/img/temporary_remove_icon.png'),
      addDistrictImg: require('@/assets/img/add_district_icon.png'),
      style: {
        titleWrapper: 'width: 418px; justify-content: space-between; margin-bottom: 30px;',
        answerWrapper: 'width: 100%; justify-content: start;',
        categoryWrapper: 'width: 97%; justify-content: start; flex-wrap : wrap;',
        towardWrapper: 'width: 60%; justify-content: start; flex-wrap : wrap;',
        genderWrapper: 'width: 80%; justify-content: start; flex-wrap : wrap;',
        jobWrapper: 'width: 100%; justify-content: start; flex-wrap : wrap;',
        ageWrapper: 'width: 100%; justify-content: start; flex-wrap : wrap;',
        regionWrapper: 'width: 70%; justify-content: start; flex-direction: column; flex-wrap : wrap; margin-bottom: 30px;',
        rewardWrapper: 'width: 100%; justify-content: start; flex-wrap : wrap;',
        periodWrapper: 'width: 58%; justify-content: space-between;',
        budgetWrapper: 'width: 100%; justify-content: space-between;',
        payPointWrapper: 'width: 58%; justify-content: space-between;'
      }
    }
  },
  methods: {
    showMyInfoModifyModal: function () {
      this.$modal.show('myInfoModifyNotification', {type: 'invalidMyInfo'})
    },
    setAnswerCountArrays: function (initAnswerNumber) {
      // 보여지는 답변칸 갯수 셋팅
      let answerCountsArray = []
      let displayAnswerCountsArray = []
      for(var i = 1; i <= initAnswerNumber; i++) {
        answerCountsArray.push(i)
        displayAnswerCountsArray.push(i)
      }
      if(displayAnswerCountsArray.length < 4) {
        // 보여지는 답변칸이 현재 4개가 아닐경우 하나 더 증가
        displayAnswerCountsArray.push(displayAnswerCountsArray.length + 1)
      }

      this.answerCountsArray = answerCountsArray
      this.displayAnswerCountsArray = displayAnswerCountsArray
      this.setUiPropData(this.$store.getters.getAdUiState)
    },
    setAnswerCountReduce: function () {
      if(this.answerCountsArray.length !== 4) {
        this.displayAnswerCountsArray.pop()
      }
      this.answerCountsArray.pop()
      this.setUiPropData(this.$store.getters.getAdUiState)
    },
    setAdPoint: function (adPoint) {
      this.adPoint = adPoint
    },
    setAvailableAdPoint: function (availableAdPoint) {
      this.availableAdPoint = availableAdPoint
    },
    isAnswerShown: function (count) {
      return this.answerCountsArray.indexOf(count) !== -1
    },
    setAreaCountArrays: function (initSelectBoxNumber) {
      let areasCountsArray = []
      let displayAreasCountsArray = []
      for(var i = 0; i < initSelectBoxNumber; i++) {
        areasCountsArray.push(i)
        displayAreasCountsArray.push(i)
      }

      if(displayAreasCountsArray.length < 5) {
        displayAreasCountsArray.push(displayAreasCountsArray.length + 1)
      }
      this.areasCountsArray = areasCountsArray
      this.displayAreasCountsArray = displayAreasCountsArray
    },
    isAreaShown: function (count) {
      return this.areasCountsArray.indexOf(count) !== -1
    },
    removeZeroValue: function (e) {
      e.target.value = e.target.value === '0' ? '' : e.target.value
    },
    setPollidePoint: function (e) {
      let rewardPoint = e.target.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')
      // eslint-disable-next-line no-useless-escape
      rewardPoint = rewardPoint.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]/gi, '')
      this.rewardPoint = isNaN(parseInt(rewardPoint)) ? 0 : parseInt(rewardPoint)
      e.target.value = this.rewardPoint
      this.$store.commit('setEnrollStateValue', {type: 'pollidePoint', value: this.rewardPoint != null && this.rewardPoint !== '' ? this.rewardPoint : 0})
    },
    setEnrollByTemporary: function (data) {
      this.isEnrollByTemporary = true
      this.temporaryAdId = data.id
      if(data.rewardType != null) {
        this.isRewardTypeCoupon = data.rewardType === 'COUPON'
      }
    },
    setUiPropData: function (value) {
      this.uiPropData = {
        isRewardTypeCoupon: value.isRewardTypeCoupon,
        titleText: value.titleText,
        titleImg: value.titleImg,
        category: value.category,
        answerText: [
          value.answer1Text,
          value.answer2Text,
          value.answer3Text,
          value.answer4Text
        ],
        answerImg: [
          value.answer1Img,
          value.answer2Img,
          value.answer3Img,
          value.answer4Img
        ],
        answerCount: this.answerCountsArray.length
      }
    },
    onlyNumber: function (e) {
      if(!((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 36 && e.keyCode < 41) || e.keyCode === 8 || e.keyCode === 46)) {
        e.returnValue = false
      }
    },
    enrollValidCheck: function () {
      let areasCountsArray = this.areasCountsArray
      let adPoint = this.adPoint
      let availableAdPoint = this.availableAdPoint
      let errorCode = this.$store.getters.getEnrollAvailable({areaCounts: areasCountsArray.length, adPoint: adPoint, availableAdPoint: availableAdPoint})
      if(errorCode !== 0) {
        let messages = utils.enrollValidCheck(errorCode).split('|')
        this.$modal.show('enrollValidNotification', {validText: messages[0], validText2: messages[1], validText3: messages[2]})
      }else {
        this.enroll()
      }
    },
    enroll: async function () {
      try {
        if (this.isEnrollByTemporary) {
          // 임시저장 -> 광고올리기의 경우
          await this.$store.dispatch('adCreateByTemporaryApi', {data: this.$store.getters.getEnrollState, adId: this.temporaryAdId, beforeImgExist: this.$store.getters.getTemporaryAdImgExist})
        } else {
          // 광고올리기의 경우
          await this.$store.dispatch('adCreateApi', this.$store.getters.getEnrollState)
        }
        // 사용가능한 포인트 refresh
        await this.$store.dispatch('adUserInfoApi')
        await this.$router.push({name: 'list'})
      }catch (error) {
        alert('광고 올리기에 실패했습니다.')
        console.log(error.response)
      }
    },
    temporaryEnroll: async function () {
      try {
        if(this.isEnrollByTemporary) {
          // 임시저장 -> 임시저장일 경우
          await this.$store.dispatch('temporaryAdModifyApi', {data: this.$store.getters.getEnrollState, adId: this.temporaryAdId, beforeImgExist: this.$store.getters.getTemporaryAdImgExist})
        }else {
          // 임시저장일 경우
          await this.$store.dispatch('temporaryAdCreateApi', this.$store.getters.getEnrollState)
        }
        await this.$router.push({name: 'list'})
      } catch (error) {
        alert('광고 임시저장에 실패했습니다.')
        console.log(error)
      }
    },
    temporaryDelete: async function () {
      if(confirm('임시저장 광고를 삭제하시겠습니까?')) {
        try {
          await this.$store.dispatch('temporaryAdDeleteApi', {adId: this.temporaryAdId})
          await this.$router.push({name: 'list'})
        } catch (error) {
          console.log(error.response)
        }
      }
    },
    deleteArea: async function (index) {
      let areas = this.$store.getters.getEnrollStateValue('area')
      areas.splice(index, 1)
      areas.push(null)
      this.setAreaCountArrays(0)
      await this.sleep(30)
      let lastNonNull = areas.filter(x => x).pop()
      let indexOfLastNonNull = areas.indexOf(lastNonNull)
      this.setAreaCountArrays(indexOfLastNonNull + 1 > 0 ? indexOfLastNonNull + 1 : 1)
    },
    sleep: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  },
  async beforeRouteEnter (to, from, next) {
    function validAdUserInfo (adUserInfo) {
      if(adUserInfo.name == null || adUserInfo.name === '') {
        return false
      }
      if(adUserInfo.address == null || adUserInfo.address === '') {
        return false
      }
      if(adUserInfo.description == null || adUserInfo.description === '') {
        return false
      }
      if(adUserInfo.images[0] == null || adUserInfo.images[0] === '') {
        return false
      }
      return true
    }

    // accessToken 유효한지 체크
    if(store.getters.getAccessToken == null || store.getters.getAccessToken === '' ||
      store.getters.getRefreshToken == null || store.getters.getRefreshToken === '') {
      // 비정상적인 접근
      alert('비 정상적인 경로로 진입하여 로그인 페이지로 이동합니다.')
      localStorage.removeItem('vuex')
      next('/')
    }

    let adUserInfo = store.getters.getAdUserState
    if(validAdUserInfo(adUserInfo)) {
      if (to.params.state != null && to.params.state === 'TEMPORARY') {
        // 임시저장에서 진입했을 시 광고 값 셋팅
        try {
          let adInfoResponse = await store.dispatch('adInfoApi', {adId: to.params.adId})
          store.commit('setEnrollState', {type: 'temporary', data: adInfoResponse.data.data})
          store.commit('setAdUiState', {type: 'temporary', data: adInfoResponse.data.data})
          store.commit('setTemporaryAdImgExist', {type: 'temporary', data: adInfoResponse.data.data})
          next(async vm => {
            vm.setEnrollByTemporary(adInfoResponse.data.data)
            vm.setAnswerCountArrays(adInfoResponse.data.data.adChoices.length < 2 ? 2 : adInfoResponse.data.data.adChoices.length)
            let formattedAreas = adInfoResponse.data.data.targetAreas != null ? utils.setPackedAreas(adInfoResponse.data.data.targetAreas) : []
            vm.setAreaCountArrays(formattedAreas.length > 1 ? formattedAreas.length : 1)
            vm.setUiPropData(store.getters.getAdUiState)
          })
        } catch (error) {
          console.log(error.response)
        }
      }else {
        // 임시저장에서 진입하지 않았을 시
        // enrollstate 초기화, adUistate 초기화
        store.commit('setEnrollState', {type: 'init'})
        store.commit('setAdUiState', {type: 'init'})
        store.commit('setTemporaryAdImgExist', {type: 'init'})
        next()
      }
    }else {
      // 내정보에 비어있는 항목이 있을 시
      // enrollstate 초기화, adUistate 초기화
      store.commit('setEnrollState', {type: 'init'})
      store.commit('setAdUiState', {type: 'init'})
      store.commit('setTemporaryAdImgExist', {type: 'init'})
      next(vm => {
        vm.showMyInfoModifyModal()
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // enrollstate 초기화, adUistate 초기화
    store.commit('setEnrollState', {type: 'init'})
    store.commit('setAdUiState', {type: 'init'})
    store.commit('setTemporaryAdImgExist', {type: 'init'})
    next()
  },
  created: function () {
    // IE에서 vue-slide-bar 지원안하는 문제 대비 동적 component 설정
    if(this.$browserDetect.isIE) {
      this.$options.components['budget-input'] = () => import('../../board/elements/budgetInputIE.vue')
    }else {
      this.$options.components['budget-input'] = () => import('../../board/elements/budgetInput.vue')
    }

    // 임시광고에서 폴라이드 포인트 값이 있을시 포인트 값 셋
    let beforeRewardPoint = this.$store.getters.getEnrollStateValue('pollidePoint')
    this.rewardPoint = beforeRewardPoint

    // 초기처리
    this.setAdPoint(this.$store.getters.getAdUserStateValue('adPoint'))
    this.setAvailableAdPoint(this.$store.getters.getAdUserStateValue('availableAdPoint'))
    this.setAnswerCountArrays(2)
    this.setAreaCountArrays(1)
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getAdUiState, value => {
      this.isRewardTypeCoupon = value.isRewardTypeCoupon
      this.setUiPropData(value)
    }, {
      deep: true
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.itemName {
  font-size: 11px;
  color: rgb(0,153,255);
}

.enrollWrapper{
  display : -webkit-flex;
  display : flex;
  margin: 0;
  padding: 0;
  flex: 1;
}

.leftSideWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  background-color: white;
  width: 620px;
}

.leftSideContentWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  padding: 0 32px;
  height: calc(100% - 82px);
}

.mainContentsWrapper{
  position: relative;
  flex: 1;
  margin: 0;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mainContentsWrapper::-webkit-scrollbar{
  display: none;
}

.elementWrapper{
  display : -webkit-flex;
  display : flex;
  margin: 20px 0;
}

.titleInputTextWrapper{
  display : -webkit-flex;
  display: flex;
  align-items: flex-end;
  width: 320px;
}

.titleImgWrapper{
  width: 80px;
  height: 58px;
}

.answerInputDiv{
  width: 120px;
  margin-right: 18px;
  display: flex;
  display: -ms-flexbox;
  align-items: center;
}

.answerAddBtn {
  cursor: pointer;
  border: 2px solid black;
  vertical-align: center;
  text-align: center;
  padding: 10px;
  font-size: 13px;
  width: 100px;
}

.areaAddBtn {
  display : -webkit-flex;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  border: 2px solid black;
  font-size: 13px;
  width: 156px;
  height: 40px;
}

.areaAddBtn > img {
  margin-left: 10px;
  height: 24px;
  width: 24px;
}

.areaInputDiv {
  display: flex;
  display: -ms-flexbox;
}

.areaInputDiv > .deleteAreaText {
  cursor: pointer;
  text-decoration: underline;
  font-size: 10px;
  height: 16px;
  width: 20px;
}

.rewardElementDiv{
  display: flex;
  display: -ms-flexbox;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 100%;
  height: 55px;
}

.rewardInputDiv{
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  justify-content: left;
  font-size: 10px;
}

.rewardInputDiv > input[type="text"]{
  padding: 0 0 5px;
  width: 20%;
  font-size: 14px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

.periodInputDiv, .payPointInputDiv{
  font-size: 10px;
  margin: 10px 0;
  width: 140px;
}

.payPointInputDiv > div{
  font-size: 13px;
  margin-top: 20px;
}

.payPointInputDiv > div > input[type="text"]{
  margin-right: 5px;
  padding: 0 0 5px;
  font-size: 20px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

.rightSideWrapper{
  position: relative;
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  width: 356px;
  background-color: rgb(245,246,250)
}

.mobileUIWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
}

.actionBtnWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 90px;
}

.actionBtnWrapper > .temporaryRemoveBtn{
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
  height: 50px;
  font-weight: bold;
  font-size: 16px;
  border: 2px solid rgb(0,153,255);
  border-radius: 0.3rem;
  background-color: white;
  width: 55px;
}

.actionBtnWrapper > .temporaryRemoveBtn:focus{
  outline: none;
}

.temporaryRemoveBtn > img {
  height: 40px;
  width: 40px;
}

.actionBtnWrapper > .temporaryBtn{
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
  height: 50px;
  font-weight: bold;
  font-size: 15px;
  border: none;
  border-radius: 0.3rem;
  color: white;
  background-color: black;
  width: 90px;
}

.actionBtnWrapper > .temporaryBtn:focus{
  outline: none;
}

.actionBtnWrapper > .enrollBtn{
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
  height: 50px;
  font-weight: bold;
  font-size: 15px;
  border: 2px solid rgb(0,153,255);
  border-radius: 0.3rem;
  color: white;
  background-color: rgb(0,153,255);
  width: 100px;
}

.actionBtnWrapper > .enrollBtn:focus{
  outline: none;
}

.actionBtnWrapper > .enrollBtn:disabled{
  cursor: default;
  border: 2px solid rgb(207,207,207);
  border-radius: 0.3rem;
  color: white;
  background-color: rgb(207,207,207);
  outline: none;
}

.rewardPointValue{
  text-align: center;
  font-size: 13px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/enroll.vue